<template>
  <div class="option">
    <a
      :href="contentUrl"
      :aria-label="`${tStatic('caiAccessibilityProductCardInfoText')} ${partName}`"
      @click="handleProductClick">
      <div class="title" role="heading" aria-level="2">{{ partName }}</div>
      <div class="subtitle" :aria-label="`${tStatic('articleNumberLabel')} ${partNumber}`">{{ tStatic('articleNumberLabel') }} {{ partNumber }}</div>
      <div>
        <div v-if="isQuoteItem" class="product-quoted-item">
          <div v-html="tStatic('requestQuoteContent')"></div>
        </div>
        <div v-else class="status">
          <oie-product-status v-if="stockMessage && stockStatus" :status="stockStatus" :text="stockMessage"></oie-product-status>
          <div class="option-price__main" :aria-label="`${tStatic('priceLabel')} ${formatPrice(price, currency, region)}`">
            <span>
              <b>{{ formatPrice(price, currency, region) }}</b>
            </span>
            <span>
              {{ vatIncluded ? tStatic('priceIncludingVat') : tStatic('priceExcludingVat') }}
            </span>
          </div>
        </div>
      </div>
    </a>
  </div>
</template>

<script>
import gtm from '@/core/enhanced-ecommerce-gtm'

export default {
  props: {
    sessionId: {
      type: String,
      required: true
    },
    contentUrl: {
      type: String,
      required: true
    },
    partName: {
      type: String,
      required: true
    },
    partNumber: {
      type: String,
      required: true
    },
    currency: {
      type: String,
      default: null
    },
    region: {
      type: String,
      default: null
    },
    isQuoteItem: {
      type: Boolean,
      default: false
    },
    price: {
      type: Number,
      default: null
    },
    vatIncluded: {
      type: Boolean,
      default: false
    },
    stock: {
      type: Number,
      default: null
    },
    stockStatus: {
      type: String,
      default: null
    },
    stockMessage: {
      type: String,
      default: null
    }
  },
  methods: {
    formatPrice(price, currency, region) {
      if(!region || !currency) {
        console.log('currency or region not returned.')
        return price
      }
      return new Intl.NumberFormat(region, { style: 'currency', currency, maximumFractionDigits: 2, minimumFractionDigits: 2 }).format(price)
    },
    handleProductClick(event) {
      event.preventDefault()
      const separator = this.contentUrl.includes('?') ? '&' : '?'
      const trackingUrl = `${this.contentUrl}${separator}chatSession=${this.sessionId}`

      localStorage.setItem('chat_conversion', JSON.stringify({ chatSessionId: this.sessionId }))
      gtm.chatProductClick(this.sessionId, this.partNumber)
      window.open(trackingUrl, '_self')
    }
  }
}
</script>

<style scoped lang="scss">
.option {
  display: flex;
  padding: 0.5rem;
  background-color: #fff;
  border: 1px solid #ccc;

  &:hover {
    background-color: #eaeaea;
  }

  &:not(:last-child) {
    margin-bottom: 0.625rem;
  }

  a {
    color: #000;
    text-decoration: none;
    width: 100%;
  }
  .stock-details{
    display: flex;
    align-items: center;
    gap: 0.25rem;
  }
}

.title {
  font-weight: bold;
}

.subtitle {
  font-size: 0.75rem;
  margin-bottom: 0.5rem;
}

.status {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.product-quoted-item{
  padding: 0.3rem;
  font-size: 0.75rem;
  background-color: #f7efe1;
  border: 1px solid #9d6917;
}
</style>
